import actions from '../actions/actionTypes';
export const INITIAL_STATE = {
  plpSelection: {
    selectedViewAllProducts: [],
    selectedPlpProducts: [],
    selectedSearchProducts: [],
  },
};
const nonFilterPlpSelection = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.SET_NON_FILTER_PLP_SELECTION:
      return {
        plpSelection: {
          ...state.plpSelection,
          [payload.category]: payload.data,
        },
      };

    case actions.CLEAR_NON_FILTER_PLP_SELECTION:
      return {
        plpSelection: {
          ...state.plpSelection,
          [payload.category]: [],
        },
      };

    default:
      return state;
  }
};

export default nonFilterPlpSelection;
